// extracted by mini-css-extract-plugin
export default {"horizontal":"styles_horizontal__Gi2JI","vertical":"styles_vertical__y9Vsv"};